<!-- Copyright 2025 by Common Good Learning Tools -->
<template><div class="k-lti-chooser k-main-wrapper">
	<div class="d-flex align-center justify-center flex-wrap pt-4" v-if="initialized && mode==''">
		<div class="k-lti-chooser-top-option elevation-3" @click="top_option_clicked('sandbox')">
			<div class="k-lti-chooser-top-option-text">Browse Your Content Sandbox</div>
			<v-icon color="#fff" class="mt-2">fas fa-umbrella-beach</v-icon>
			<div class="k-lti-chooser-top-option-note">All activities you’ve created or edited yourself</div>
		</div>

		<div class="k-lti-chooser-top-option elevation-3" @click="top_option_clicked('favorites')">
			<div class="k-lti-chooser-top-option-text">Browse Favorite Collections</div>
			<v-icon large color="#fff" class="mt-2">fas fa-bookmark</v-icon>
			<div class="k-lti-chooser-top-option-note"></div>
			<v-spacer/>
		</div>

		<div class="k-lti-chooser-top-option elevation-3" @click="top_option_clicked('courses')">
			<div class="k-lti-chooser-top-option-text">Browse Course Collections</div>
			<v-icon large color="#fff" class="mt-2">{{top_option_icon('classes')}}</v-icon>
			<div class="k-lti-chooser-top-option-note"></div>
			<v-spacer/>
		</div>

		<div class="k-lti-chooser-top-option elevation-3" @click="top_option_clicked('repos')">
			<div class="k-lti-chooser-top-option-text">Browse {{site_config.resourcerepos_noun}}</div>
			<v-icon large color="#fff" class="mt-2">{{top_option_icon('resourcerepos')}}</v-icon>
			<div class="k-lti-chooser-top-option-note"></div>
			<v-spacer/>
		</div>

		<div class="k-lti-chooser-top-option elevation-3" @click="top_option_clicked('my')">
			<div class="k-lti-chooser-top-option-text">Browse Your <nobr>“My Collections”</nobr></div>
			<v-icon large color="#fff" class="mt-2">{{top_option_icon('mycollections')}}</v-icon>
			<div class="k-lti-chooser-top-option-note"></div>
			<v-spacer/>
		</div>

		<div class="k-lti-chooser-top-option elevation-3" @click="top_option_clicked('search')">
			<div class="k-lti-chooser-top-option-text">Search All Content in {{site_config.app_name}}</div>
			<v-icon color="#fff" class="mt-2">fas fa-search</v-icon>
			<div class="k-lti-chooser-top-option-note">by Keywords/Terms or Standards</div>
			<v-spacer/>
		</div>
	</div>

	<div v-if="mode=='favorites'">
		<h2 class="d-flex align-center pt-4 pl-5">
			<div>Favorite Collections</div>
		</h2>

		<FavoritesIndex :lti_chooser="true" @go_to_collection="go_to_collection" @hide_index="mode=''" />
	</div>

	<div v-if="mode=='courses'">
		<h2 class="d-flex align-center pt-4 pl-5">
			<div>Course Collections</div>
		</h2>

		<CourseIndex :lti_chooser="true" @go_to_collection="go_to_collection" @hide_index="mode=''" />
	</div>

	<div v-if="mode=='repos'">
		<h2 class="d-flex align-center pt-4 pl-5">
			<div>{{site_config.resourcerepos_noun}}</div>
		</h2>

		<RepositoriesIndex :lti_chooser="true" @go_to_collection="go_to_collection" @hide_index="mode=''" />
	</div>

	<div v-if="mode=='my'">
		<h2 class="d-flex align-center pt-4 pl-5">
			<div>My Collections</div>
		</h2>

		<MyCollectionsIndex :lti_chooser="true" @go_to_collection="go_to_collection" @hide_index="mode=''" />
	</div>
</div></template>

<script>
import FavoritesIndex from './../collectionlist/FavoritesIndex'
import CourseIndex from './../collectionlist/CourseIndex'
import RepositoriesIndex from './../collectionlist/RepositoriesIndex'
import MyCollectionsIndex from './../collectionlist/MyCollectionsIndex'
import { mapState, mapGetters } from 'vuex'

export default {
	components: { FavoritesIndex, CourseIndex, RepositoriesIndex, MyCollectionsIndex },
	props: {
		// community: { type: Object, required: true },
	},
	data() { return {
		pm_verbose: 'show_untrusted',
		// pm_verbose: '',
		pm_initialize_try_count: 0,
		sparkl_pm_data: {},
		initialized: false,
		mode: '',
		back_fn: null,
	}},
	computed: {
		...mapState(['user_info', 'site_config']),
	},
	created() {
		// for some reason this is set to 'scroll', which makes it so there is always space for a scroll bar even when we don't need it
		$('html').css('overflow-y', 'auto')
		vapp.lti_chooser_component = this
	},
	mounted() {
		this.$nextTick(x=>{
			this.pm_initialize()
		})
	},
	methods: {
		// this is the initialize fn for window B that is embedded in/opened from window A
		// here, we establish the eventListener for postMessages, then wait for a message from window A establishing the connection.
		pm_initialize() {
			// host application origins that are allowed to embed this instance of cureum; brought in via site_config
			// the chooser can be embedded in sparkl_origin, as well as localhost (for testing purposes)
			let trusted_origins = [this.site_config.sparkl_origin, 'http://localhost:8072']

			// set up eventListener for postMessages
			window.addEventListener('message', (event) => {
				// event.source is the window that sent the message (the window that included the iframe)
				// event.origin is the origin that sent it; make sure we trust it
				// event.data is what was sent

				// Do we trust the sender of this message?
				if (!trusted_origins.includes(event.origin)) {
					if (this.pm_verbose == 'show_untrusted') {
						if (event.origin == window.location.origin) console.warn('   PMX SPARKL_LTI_CHOOSER !== message in cureum from self')
						else console.warn('   PMX SPARKL_LTI_CHOOSER !== message in cureum from untrusted origin: ' + event.origin, event.data)
					}
					return
				}

				// messages that we're listening to here should all have the form {msg: 'xxx', data: ...}
				if (typeof(event.data) != 'object' || empty(event.data.msg)) {
					return
				}
				let msg = event.data.msg
				let data = event.data.data

				// message from hosting window to establish connection
				if (msg == 'establish_connection') {
					// if we already established the connection, return
					if (this.embedded_source) {
						if (this.pm_verbose) console.warn('   PMX SPARKL_LTI_CHOOSER <-- establish_connection received after connection already established')
						return
					}

					if (this.pm_verbose) console.warn('   PMX SPARKL_LTI_CHOOSER <-- EMBEDDED_SOURCE ESTABLISHED FROM HOST', data)

					// it looks like we get errors if embedded_source is reactive -- but that's OK; it doesn't need to be
					this.embedded_source = event.source
					this.embedded_source_origin = event.origin

					// if we get to here, send a confirmation message that the establish_connection message has been received
					this.pm_send('received_establish_connection')

					// data should include a sparkl_session_id along with the user's email, name_given, and name_family
					this.sparkl_pm_data = data

					// call a service here to verify the sparkl session. however, we want to make sure we start a NEW session here, so clear U.session_id first
					U.session_id = ''
					const payload = {
						sparkl_session_id: this.sparkl_pm_data.sparkl_session_id, 
						email: this.sparkl_pm_data.email, 
						name_given: this.sparkl_pm_data.name_given, 
						name_family: this.sparkl_pm_data.name_family, 
					}
					U.ajax('authenticate_lti_chooser_from_sparkl', payload, result=>{
						// console.warn('authenticate_lti_chooser_from_sparkl', result)
						if (result.status != 'ok') {
							// if status is 'user_does_not_exist', we don't have a cureum user for this email; no matter what the status is, let LTIChooserSparkl know this isn't working
							this.pm_send('authentication_error', result)
							// then return
							return
						}
				
						// set the session_id to the received cureum_session_id
						U.session_id = result.cureum_session_id

						// set user_data as done in initialize_app
						this.$store.commit('set', ['user_info', new User_Info(result.user_info)])

						// set up site_config as done in initialize_app (we should always get site_config)
						if (result.site_config) {
							// set property-by-property, so that we retain default values set above
							for (let key in result.site_config) {
								this.$store.commit('set', [this.site_config, key, result.site_config[key]])
							}
						} else console.log('site_config not received!')
						this.$store.commit('write_site_config')

						// also save subjects
						this.$store.commit('set', ['subjects', result.subjects])

						// call get_classes to get the user's content
						this.$store.dispatch('get_classes').then(x=>{
							this.initialized = true
						})
					})
					

				//////////////////////////////////
				// HERE ARE THE COMMANDS THAT CAN BE SENT FROM THE HOSTING WINDOW

				} else if (msg == 'back_btn_clicked') {
					this.back_btn_clicked(data)

				// } else if (msg == 'xxx') {
				// 	this.xxx(data)

					// more messages here...
				} else {
					console.warn('   PMX SPARKL_LTI_CHOOSER !== received unprocessed message: ', msg, data)
				}
			});
		},

		pm_send(msg, data) {
			// if we're not embedded, return
			if (!this.embedded_source) return

			if (this.pm_verbose) console.warn('   PMX SPARKL_LTI_CHOOSER --> pm_send: ' + msg)

			try {
				// queue a message to be sent; second param specifies what the origin of the target window must be for the event to be dispatched
				this.embedded_source.postMessage({msg: msg, data: data}, this.embedded_source_origin)
			} catch(e) {
				console.warn('   PMX SPARKL_LTI_CHOOSER !== pm_send error caught: ', e)
			}
		},

		top_option_icon(x) {
			if (x == 'classes') return this.site_config.customized_tabs.classes?.icon || 'fas fa-chalkboard'
			if (x == 'resourcerepos') return this.site_config.customized_tabs.resourcerepos?.icon || 'fas fa-diagram-project'
			if (x == 'mycollections') return this.site_config.customized_tabs.mycollections?.icon || 'fas fa-cubes-stacked'
		},

		top_option_clicked(option) {
			if (option == 'sandbox') {
				this.mode = ''
				this.show_search({
					default_source: 'my',
					default_crit: 'keywords',
				})

			} else if (option == 'search') {
				this.mode = ''
				this.show_search({
					default_source: 'site'
				})

			} else {
				// this will cause the collection tiles to show
				this.mode = option
			}

			// set back_fn
			this.set_default_back_fn()
		},

		set_default_back_fn() {
			this.back_fn = () => {
				// console.warn('default_back_fn')
				this.mode = ''
				vapp.hide_search()
			}
		},

		set_sparkl_preview_back_fn() {
			// if we're previewing a sparkl activity and the user clicks back, we want to hide the preview and re-set the back_fn to the default_back_fn defined above
			this.back_fn = () => {
				// console.warn('sparkl_preview_back_fn')
				// note that it's important to call close_sparkl from sparkl_embed.controller_component
				vapp.$refs.sparkl_embed.controller_component.close_sparkl()
				
				setTimeout(x=>this.set_default_back_fn(), 100)
			}
		},

		go_to_collection(collection) {
			// console.warn('go_to_collection', collection)
			// do what we would do if you initiate_search from Collection.vue
			this.$store.dispatch('get_learning_progression', collection.course_code).then((found)=>{
				this.show_search({
					default_source: collection,
					default_crit: 'keywords',
				})
			})
		},

		show_search(params) {
			if (empty(params)) params = {}
			params.lti_chooser = true
			params.search_only = true
			params.item_types = ['activities']	// could add 'resources' later if we want to allow creating a sparkl activity from a resource on the fly...

			// call initialize_search to show the ResourceSearch UI
			vapp.initiate_search(params)
		},

		lti_chooser_choose(sparkl_activity_id) {
			this.pm_send('lti_chooser_choose', {sparkl_activity_id: sparkl_activity_id})
		},

		back_btn_clicked() {
			// console.warn('back_btn_clicked from pm')
			// if the user clicks the back button in the LTIChooserSparkl component, it will passs control to us here.
			// if we have a back_fn to execute, we execute it
			if (!empty(this.back_fn)) {
				this.back_fn()

			// otherwise we send a message back that the btn click wasn't handled
			} else {
				this.pm_send('back_btn_not_handled')
			}
			this.back_fn = null
		},
	}
}
</script>

<style lang="scss">
.k-lti-chooser {
	background-color:#eee;
	height:100%;

	.k-main-collection {
		background-color:transparent!important;
	}
}

.k-lti-chooser-top-option {
	width:200px;
	height:160px;
	display:flex;
	flex-direction:column;
	justify-content: center;
	background-color:$v-indigo-darken-2;
	border:$v-indigo-darken-4 3px solid;
	color:#fff;
	text-align:center;
	padding:12px;
	border-radius:12px;
	margin:12px;
	cursor:pointer;
}

.k-lti-chooser-top-option-text {
	font-size:20px;
	line-height:25px;
	font-weight:800;
}

.k-lti-chooser-top-option-note {
	font-size:14px;
	line-height:18px;
	margin-top:8px;
}
</style>
